
export default function Footer() {
  return (
    <footer className="px-6 py-12 bg-black/30 backdrop-blur-sm border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="font-['Pacifico'] text-2xl text-white mb-4 md:mb-0">
            Stratava AI
          </div>
          <div className="flex space-x-8 text-white/60">
            <a className="hover:text-white transition-colors cursor-pointer" href="#">Privacy Policy</a>
            <a className="hover:text-white transition-colors cursor-pointer" href="#">Terms of Service</a>
            <a className="hover:text-white transition-colors cursor-pointer" href="#">Support</a>
            <a className="hover:text-white transition-colors cursor-pointer" href="https://readdy.ai/?origin=logo">Website Builder</a>
          </div>
        </div>
        <div className="text-center text-white/40 mt-8">
          © 2024 Stratava AI. The ultimate destination for AI-driven interactive entertainment.
        </div>
      </div>
    </footer>
  );
}
